// angular
import { Component, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { AppService } from '../../../app.service';
import { MeRegisterService } from '../../register/me-register.service';

@Component({
    selector: 'me-register-verification',
    templateUrl: './register-verification.component.html',
    styleUrls: ['./register-verification.component.scss']
})

export class MeRegisterVerificationComponent implements OnInit {
    data = null;
    url = 'success/register-verification';
    folder = 'core';

    constructor(
        public appService: AppService,
        public fb: FormBuilder,
        public translate: TranslateService,
        public meRegisterService : MeRegisterService
    ) {

    }

    ngOnInit() {
        this.getContent();
        this.translate.onLangChange.subscribe(value => {
            this.getContent();
        });
    }

    getContent() {
        this.appService.getStoryBlokDataForClinic(this.url).subscribe(res => {
            this.data = res['story']['content'];
        });
    }

    resendEmail(value) {
        this.appService.isLoading = true;
        this.meRegisterService.resendVerify({
            email : this.meRegisterService.patientEmail
        }).subscribe(res => {
            this.appService.isLoading = false;
        });
    }p
}
